import $ from 'jquery';
import "slick-carousel";
import AOS from "aos";
import "nouislider";
import * as noUiSlider from '../../node_modules/nouislider/dist/nouislider';
import Rellax from "../../node_modules/rellax/rellax";

$(document).ready(function() {
    $(window).scroll(function() {
        var scrollDistance = $(window).scrollTop();
        // Assign active class to nav links while scolling
        $('.section-display').each(function(i) {
            if ($(this).position().top <= scrollDistance) {
                $('.menu-dots a.active').removeClass('active');
                $('.menu-dots a').eq(i).addClass('active');
            }
        });
    }).scroll();

    //SLIDER VIDEO
    $('.slider-infographic').slick({
        arrows: false,
        dots: true,
        vertical: true,
        verticalSwiping: false,
        autoplay: false,
        infinite: false,
        swipe: false,
    });
    $('.slider-infographic').on('afterChange', function(event, slick, currentSlide) {
        if (currentSlide === 3) { //So, how much do you need to retire?
            $(".salary-bar").addClass('active');
            console.log('slide 3');
        }
        if (currentSlide === 4) { //How Can You Secure Your Future?
            $(".graphic-2 .graphic-col").addClass('active');
            console.log('slide 4');
        }
    });

    $('a[data-slide]').click(function(e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider-infographic').slick('slickGoTo', slideno - 1);
    });

    //SLIDER VIDEO
    $('.slider-video').slick({
        arrows: false,
        dots: true,
    });
    //SLIDER VERTICAL
    $('.slider-vertical').slick({
        arrows: true,
        dots: false,
        vertical: true,
        verticalSwiping: false,
    });

    //SLIDER SECURE RETIREMENT
    $('.slider-secure-retirement-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-secure-retirement',
    });
    $('.slider-secure-retirement').slick({
        asNavFor: '.slider-secure-retirement-for',
        arrows: true,
        dots: false,
    });

    //SLIDER HORIZONTAL
    $('.slider-horizontal').slick({
        arrows: true,
        dots: false,
    });

    //AOS
    AOS.init({
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 120, // offset (in px) from the original trigger point
        delay: 50, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease-in-out', // default easing for AOS animations
        once: true // whether animation should happen only once - while scrolling down
    });

    //GRAPHIC 4
    $(".hover-button-1").hover(
        function() {
            $('.hover-1').css("visibility", "visible");
        },
        function() {
            $('.hover-1').css("visibility", "hidden");
        }
    );
    $(".hover-button-2").hover(
        function() {
            $('.hover-2').css("visibility", "visible");
        },
        function() {
            $('.hover-2').css("visibility", "hidden");
        }
    );

    //noUISlider DESKTOP
    var slider = document.getElementById('nouislider');
    var sliderValueSpan = document.getElementById('slider-value');
    noUiSlider.create(slider, {
        start: [40],
        step: 5,
        range: {
            'min': [40],
            'max': [100]
        },
        pips: {
            mode: 'values',
            values: [55, 75, 80, 100],
            density: 3
        }
    });
    slider.noUiSlider.on('update', function(values, handle) {
        var sliderValue = values[handle];
        //console.log(sliderValue);
        if (sliderValue == 55.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:first').addClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step1');
            $('.noUi-handle:before').css("content", "hello");
        } else if (sliderValue == 75.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(1)').addClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(2)').removeClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step2');
        } else if (sliderValue == 80.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(2)').addClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(1)').removeClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step3');
        } else if (sliderValue == 100.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(3)').addClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step4');
        } else {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-handle').removeClass('active step1 step2 step3 step4');
        }
    });

    //NOUISLIDER MOBILE
    var sliderMobile = document.getElementById('nouislider-mobile');
    var sliderValueSpanMobile = document.getElementById('slider-value');
    noUiSlider.create(sliderMobile, {
        start: [40],
        step: 5,
        direction: 'ltr',
        orientation: 'vertical',
        range: {
            'min': [40],
            'max': [100]
        },
        pips: {
            mode: 'values',
            values: [55, 75, 80, 100],
            density: 3
        }
    });
    sliderMobile.noUiSlider.on('update', function(values, handle) {
        var sliderValue = values[handle];
        // console.log(sliderValue);
        if (sliderValue == 55.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:first').addClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step1');
            $('.noUi-handle:before').css("content", "hello");
        } else if (sliderValue == 75.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(1)').addClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(2)').removeClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step2');
        } else if (sliderValue == 80.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(2)').addClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(1)').removeClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step3');
        } else if (sliderValue == 100.00) {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-pips').find('.noUi-value-large:eq(3)').addClass('active');
            $('.noUi-handle').removeClass('step1 step2 step3 step4');
            $('.noUi-handle').addClass('active step4');
        } else {
            $('.noUi-pips').find('.noUi-value-large').removeClass('active');
            $('.noUi-handle').removeClass('active step1 step2 step3 step4');
        }
    });
    $('.nouislider .noUi-handle').on('focus', function(e) {
        $(this).addClass('effect-stop');
    });

    //PARALLAX
    var rellax = new Rellax('.rellax', {
        speed: -2,
        center: true
    });
});